<header class="site-header header-style-4">
  <!-- top bar -->

  <!-- top bar END-->
  <div class="main-bar">
    <div class="container header-contant-block">
      <div class="row">
        <div class="col-md-2">
          <div class="dez-logo "><a href="/">
              <img src="/assets/NUEVO_LOGO_MPD_2021.png" style="height: 130px;" alt=""></a>
          </div>
        </div>
        <div class="col-md-3">
          <a style="display: inline !important;"
            href="http://www.planificacion.gob.bo/uploads/AGENDA_PATRIOTICA2025_MPD.pdf" target="_blank|_self">
            <img class="animation" src="/assets/Logo_Agenda_patriotica-01.png" style="margin-top: 30px;height: 70px;"
              alt="">
          </a>
        </div>
        <div class="col-md-3" style="text-align:right;">
          <!-- <a style="display: inline !important;" href="https://seguimiento.planificacion.gob.bo">
            <img class="animation" src="/assets/contacto.png" style="margin-top: 30px;height: 70px;" alt="">
          </a> -->
        </div>
        <div class="col-md-3" style="text-align: center;">
          <div class="dez-logo logo_menu_l "><a style="display: inline !important;"
              href="http://www.plandeempleo.bo"><img class="animation" src="/assets/plandeempleo.png"
                style="margin-top: 30px;height: 70px;" alt=""></a></div>
        </div>
      </div>
    </div>
  </div>
  <!-- main header -->
  <div class="sticky-header main-bar-wraper">
    <div class="main-bar clearfix ">
      <div class="slide-up">
        <div class="container clearfix bg-primary">

          <!-- website logo -->
          <div class="dez-logo mostion">
            <a href="https://www.intervencionesurbanas.bo/">
              <img class="animation piu" src="/assets/PIU.png" alt="">
            </a>
            <a href="http://www.plandeempleo.bo">
              <img class="animation empleo" src="/assets/pne.png" alt="">
            </a>
            <a href="http://www.investbolivia.gob.bo">
              <img class="animation invest" src="assets/INVESTBOL.png" alt="">
            </a>
          </div>

          <!-- nav toggle button -->
          <button data-target=".header-nav" data-toggle="collapse" type="button" class="navbar-toggle collapsed">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>

          <!-- extra nav -->
          <div class="extra-nav">
            <div class="extra-cell">
              <button id="quik-search-btn" type="button" class="site-button"><i class="fa fa-search"></i></button>
            </div>
          </div>

          <!-- Quik search -->
          <div class="dez-quik-search bg-primary">
            <form method=GET action="http://www.google.com/search">
              <input type=hidden name=ie value=UTF-8>
              <input type=hidden name=oe value=UTF-8>
              <input type=hidden name=sitesearch value="http://www.planificacion.gob.bo/">
              <input name=q size=31 maxlength=255 type="text" required="required" class="form-control"
                placeholder="Buscar...">
              <span id="quik-search-remove"><i class="fa fa-remove"></i></span>
            </form>
          </div>
          <!-- main nav -->
          <div class="header-nav navbar-collapse collapse" [ngClass]="class">
            <img style="height: 80px; margin-top: 1px;" src="/assets/NUEVO_LOGO_H_2021_BLANCO.png"
              class="logo_menu_l animation" [style.display]="!showStyle?'none':'block'" alt="">
            <ul class=" nav navbar-nav">
              <li *ngFor="let item of menu">
                <a *ngIf="item.id_contenido=='0' && item.enlace==''" routerLink="null">{{item.titulo}}<i
                    class="fa fa-chevron-down"></i></a>
                <a *ngIf="item.id_contenido=='0' && item.enlace!=''" routerLink="/{{item.enlace}}">{{item.titulo}}<i
                    class="fa fa-chevron-down"></i></a>
                <a *ngIf="item.id_contenido!='0'" routerLink="/content/{{item.id_contenido}}">{{item.titulo}}<i
                    class="fa fa-chevron-down"></i></a>
                <ul *ngIf="item.childrens.length>0" class="sub-menu">
                  <li *ngFor="let l1 of item.childrens">
                    <a *ngIf="l1.id_contenido=='0' && l1.enlace==''" routerLink="null">{{l1.titulo}}<i
                        class="fa fa-chevron-down"></i></a>
                    <a *ngIf="l1.id_contenido=='0' && l1.enlace!=''" routerLink="/{{l1.enlace}}">{{l1.titulo}}</a>
                    <a *ngIf="l1.id_contenido!='0'" routerLink="/content/{{l1.id_contenido}}">{{l1.titulo}}</a>
                    <ul *ngIf="l1.childrens.length>0" class="sub-menu">
                      <li *ngFor="let l2 of l1.childrens">
                        <a *ngIf="l2.id_contenido=='0' && l2.enlace==''" routerLink="null"> {{l2.titulo}}<i
                            class="fa fa-chevron-down"></i></a>
                        <a *ngIf="l2.id_contenido=='0' && l2.enlace!=''" routerLink="/{{l2.enlace}}"> {{l2.titulo}}</a>
                        <a *ngIf="l2.id_contenido!='0'" routerLink="/content/{{l2.id_contenido}}"> {{l2.titulo}}</a>
                        <ul *ngIf="l2.childrens.length>0" class="sub-menu">
                          <li *ngFor="let l3 of l2.childrens">
                            <a *ngIf="l3.id_contenido=='0'" routerLink="/{{l3.enlace}}"> {{l3.titulo}}</a>
                            <a *ngIf="l3.id_contenido!='0'" routerLink="/content/{{l3.id_contenido}}">{{l3.titulo}}</a>
                            <ul *ngIf="l3.childrens.length>0" class="sub-menu">
                              <li *ngFor="let l4 of l3.childrens">
                                <a *ngIf="l4.id_contenido=='0'" routerLink="/{{l4.enlace}}"> {{l4.titulo}}</a>
                                <a *ngIf="l4.id_contenido!='0'" routerLink="/content/{{l4.id_contenido}}">
                                  {{l4.titulo}}</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>

              </li>

            </ul>

          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- main header END -->
</header>


// WEBPACK FOOTER //
// ./src/app/layouts/header/header.component.html